import React from 'react';
import { Grid, GridRow, GridColumn } from 'semantic-ui-react';
import Bold from 'components/Bold';
import { WorksheetPageIndex } from 'services/worksheet/types';
import FertilizerPrintWorksheetBlocksTable from './components/FertilizerPrintWorksheetBlocksTable';
import FertilizerPrintWorksheetComments from './components/FertilizerPrintWorksheetComments';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
}

type Props = OwnProps;

export default function FertilizerPrintWorksheetBlocks(
    props: Props
): React.ReactElement {
    const { pageIndex } = props;

    return (
        <div className="print-worksheet-page-section">
            <Grid columns="1">
                <GridRow>
                    <GridColumn>
                        <Bold>Blocks</Bold>
                    </GridColumn>
                </GridRow>
            </Grid>
            <FertilizerPrintWorksheetBlocksTable pageIndex={pageIndex} />
            <FertilizerPrintWorksheetComments pageIndex={pageIndex} />
        </div>
    );
}
